export default __webpack_public_path__ + "static/media/icons8-photo-gallery-96.e994acc9.svg";